class n extends Error {
  constructor(e) {
    super(
      `Attempted to inject ${e} when one hasn't been provided. Please ensure one is provided.`
    );
  }
}
export {
  n as MissingInjectionError
};
//# sourceMappingURL=missing-injection-error.js.map
